import { useState } from "react";

interface ShareBarProps {
  title: string;
}

export default function ShareBar({ title }: ShareBarProps) {
  const [toast, setToast] = useState("");

  const showToast = (msg: string) => {
    setToast(msg);
    window.setTimeout(() => setToast(""), 2000);
  };

  const handleCopy = async () => {
    const url = typeof window !== "undefined" ? window.location.href : "";
    try {
      await navigator.clipboard.writeText(url);
      showToast("链接已复制，快去分享吧");
    } catch {
      showToast("复制失败，请手动复制地址栏链接");
    }
  };

  const handleShare = (platform: string) => {
    showToast(`${platform}分享为前端演示，暂未接入真实接口`);
  };

  return (
    <div className="relative">
      <div className="flex flex-wrap items-center gap-2.5">
        <span className="text-sm text-foreground-500 mr-1">分享：</span>
        <button
          type="button"
          onClick={handleCopy}
          className="inline-flex items-center gap-1.5 h-9 px-4 rounded-md bg-primary-600 text-background-50 text-sm font-medium hover:bg-primary-700 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-link"></i>
          复制链接
        </button>
        <button
          type="button"
          onClick={() => handleShare("微博")}
          className="inline-flex items-center justify-center w-9 h-9 rounded-md bg-background-100 text-foreground-700 hover:bg-accent-100 hover:text-accent-700 transition-colors cursor-pointer"
          aria-label={`分享到微博 - ${title}`}
          title="分享到微博"
        >
          <i className="ri-weibo-fill"></i>
        </button>
        <button
          type="button"
          onClick={() => handleShare("微信")}
          className="inline-flex items-center justify-center w-9 h-9 rounded-md bg-background-100 text-foreground-700 hover:bg-accent-100 hover:text-accent-700 transition-colors cursor-pointer"
          aria-label={`分享到微信 - ${title}`}
          title="分享到微信"
        >
          <i className="ri-wechat-fill"></i>
        </button>
        <button
          type="button"
          onClick={() => handleShare("QQ")}
          className="inline-flex items-center justify-center w-9 h-9 rounded-md bg-background-100 text-foreground-700 hover:bg-accent-100 hover:text-accent-700 transition-colors cursor-pointer"
          aria-label={`分享到QQ - ${title}`}
          title="分享到QQ"
        >
          <i className="ri-qq-fill"></i>
        </button>
      </div>

      {toast && (
        <div className="absolute -top-12 left-0 px-3 py-2 rounded-md bg-foreground-950/90 text-background-50 text-xs animate-fade-in whitespace-nowrap">
          {toast}
        </div>
      )}
    </div>
  );
}